export const SELECTORS = {
  PRODUCT_PURCHASE_SIDE_BAR: 'js-product-purchase-side-bar',
  PRODUCT_PURCHASE_BAR: 'js-purchase-bar'
};
